module.exports = __webpack_public_path__ + "static/media/transparency.4182021e.svg";